import React, { ReactElement } from 'react'
import { Text, Flex, Image } from 'theme-ui'
import ExpertsIcon from 'images/organization/features/malware/experts-section-icon.svg'
import ExpertImage1 from 'images/demo/expert-1.png'
import ExpertImage2 from 'images/demo/expert-2.png'
import ExpertImage3 from 'images/demo/expert-3.png'
import ExpertsBg from 'images/organization/features/malware/experts-bg.svg'
import ExpertItem from './ExpertItem'
import { Svg } from 'ui'
import { TextWithBreakpointVariant } from 'ui/TextWithBreakpointVariant'

export default function TrustedByExperts(): ReactElement {
  return (
    <Flex
      sx={{
        flexDirection: 'column',
        gap: ['8rem', '10rem'],
        justifyContent: 'center',
        textAlign: 'center',
        px: ['1.6rem', '1.6rem', 0],
      }}
    >
      <Flex
        sx={{ position: 'relative', flexDirection: 'column', gap: '1.6rem', alignItems: 'center' }}
      >
        <Svg svg={ExpertsIcon} descriptiveText="Trusted by experts section icon" />
        <TextWithBreakpointVariant
          variant={['size24Weight600', 'size40Weight600']}
          sx={{ color: 'white', mt: '-4rem', zIndex: 'zIndex1' }}
        >
          Trusted by experts
        </TextWithBreakpointVariant>
        <Svg
          svg={ExpertsBg}
          sx={{ position: 'absolute', top: '-5rem', width: ['70rem', 'auto'], zIndex: 'zIndex0' }}
          descriptiveText="Decorative background for trusted by experts section"
        />
      </Flex>
      <Flex
        sx={{
          columnGap: ['8.2rem', '3.8rem', '3.8rem'],
          rowGap: ['8.2rem', '8.2rem', '3.8rem'],
          textAlign: 'left',
          justifyContent: 'center',
          flexDirection: ['column', 'row'],
          flexWrap: ['nowrap', 'wrap'],
          px: [0, '2.4rem', 0],
        }}
      >
        <ExpertItem
          image={<Image data-testid="expert1-image" alt="expert-image" src={ExpertImage1} />}
          title='"Awesome support. Awesome product"'
          comment='"Best support you can find. These guys know their stuff
           — it’s easy to use, easy to manage, easy to deploy. These folks are genius."'
          expertName="Mike L"
          expertPosition={
            <Text>
              Chief Operating Officer,
              <br /> Data Net Solutions Group
            </Text>
          }
          linkedInUrl="https://www.linkedin.com/in/mike-l-755558b/"
        />
        <ExpertItem
          image={<Image data-testid="expert2-image" alt="expert-image" src={ExpertImage2} />}
          title='"Great support and easy to setup on serverless environments"'
          comment='"This is a great tool for serverless environments that need DNS filtering.
           The entire team that we have worked with is always very responsive and it&apos;s a pleasure getting to know their product better.
            Cost always comes into play but it is quite cheap per seat."'
          expertName="Thomas Farrell"
          expertPosition={
            <Text>
              Director of Operations,
              <br /> Network Information Technologies, LLC
            </Text>
          }
          linkedInUrl="https://www.linkedin.com/in/thomas-farrell-82186572/"
        />
        <ExpertItem
          image={<Image data-testid="expert3-image" alt="expert-image" src={ExpertImage3} />}
          title='"Excellent DNS service"'
          comment='"One of the best designed interfaces my team has ever interacted with.
           Not only is the product light years ahead of the competition,
            they are a fantastic partner to work with on a regular basis."'
          expertName="Rael Solin"
          expertPosition={
            <Text>
              Enterprise Lead Sales,
              <br /> Pinnacle ICT
            </Text>
          }
          linkedInUrl="https://www.linkedin.com/in/rael-solin-6bb39a11/"
        />
      </Flex>
    </Flex>
  )
}
